import Router from '~Lead/router';

export default Router;
